import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-close-tabs-dialog',
  templateUrl: './close-tabs-dialog.component.html',
  standalone: false
})
export class CloseTabsDialogComponent {

  @Output() cancel = new EventEmitter();
  @Output() confirm = new EventEmitter();

  constructor() { }

}
